module.exports = __webpack_public_path__ + "static/media/sim.2bfa64ad.png";